import React from 'react';
import {BaseProps} from "../../../infrastructure/models/props/base-props";
import styles from "../styles/live-penalties-module.module.scss";
import classNames from "classnames";
import {LivePenaltiesModuleController} from "../live-penalties-module.controller";
import {LivePenaltiesModuleHeaderTitles} from "./live-penalties-module.header.titles";

export class LivePenaltiesModuleHeaderProps extends BaseProps {
  controller: LivePenaltiesModuleController;
}

export const LivePenaltiesModuleHeader = ({controller}: LivePenaltiesModuleHeaderProps) => {
  const {state: {terms}, device: {isSmallView}} = controller;


  return (
    <div className={classNames(styles.header_container, {[styles.small_view]: isSmallView})}>
      <div className={classNames(styles.header_content)}>
        <div className={styles.corner_container}>{terms.WEB_PENALTY_POPUP_LIVE}</div>
        <LivePenaltiesModuleHeaderTitles controller={controller}/>
      </div>
    </div>

  )
}
